import { React, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { main_paige_title, menu } from "../../constants/constants";
import { setSideBarVisibility, setMyCartModalVisibility } from "../../store/actions";


function Header() {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cartItems);
  const sideBarVisibility = useSelector((state) => state.sideBarVisibility);
  const myCartModalVisibility = useSelector((state) => state.myCartModalVisibility);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isMobile = screenWidth < 768;

  const handleResize = useCallback(() => {
    setScreenWidth(window.innerWidth);
  }, []);

  const myCartHandler = (e) => {
    e.preventDefault();
    dispatch(setMyCartModalVisibility(!myCartModalVisibility));
  };

  const sidebarHandler = (e) => {
    e.preventDefault();
    dispatch(setSideBarVisibility(!sideBarVisibility));
  };

  return (
    <>
      <header className="main-header navbar-light header-sticky header-sticky-smart position-absolute fixed-top">
        <div className="sticky-area">
          <div className="container container-xxl">
            <nav className="navbar navbar-expand-xl px-0 py-2 py-xl-0 d-block">
              <div className="d-none d-xl-block">
                <div className="row align-items-center">
                  <div className="col-xl-8 mx-auto position-static">
                    <div className="d-flex mt-3 mt-xl-0 align-items-center w-100 justify-content-center">
                      <Link key="desktop_image_link" to="/" className="navbar-brand mx-8 mr-0 d-inline-block py-0">
                        <img
                          src="/luminit-logo-1.png"
                          alt="Furnitor"
                          style={{
                            maxWidth: isMobile ? "80%" : "100%",
                            height: "auto"
                          }}
                        />
                      </Link>
                      <ul className="navbar-nav hover-menu main-menu px-0 mx-xl-n4">
                        {menu.map((element, index) => {
                          const isDropdown = element.children !== undefined ? true : false;
                          const linkClassNames = isDropdown ? "dropdown-toggle nav-link p-0" : "nav-link p-0";
                          return (
                            <>
                              <li className="nav-item dropdown-item-home dropdown py-2 py-xl-5 px-0 px-xl-4" key={index}>
                                <Link key={index} to={element.to} className={linkClassNames} data-page={element.slug} style={{ fontSize: "1rem" }}>
                                  {element.title}
                                </Link>
                              </li>
                            </>
                          );
                        })}
                      </ul>
                    </div>
                  </div>
                  <div className="col-2">
                    <ul className="navbar-nav flex-row justify-content-xl-end d-flex flex-wrap text-body py-0 navbar-right">
                      <li className="nav-item">
                        <a href="/#" onClick={myCartHandler} className="nav-link position-relative px-3 menu-cart py-0">
                          <i className="far fa-shopping-basket"></i>
                          <span className="position-absolute number">{cartItems.length}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center d-xl-none">
                <button className="navbar-toggler border-0 px-0 canvas-toggle" type="button" onClick={sidebarHandler}>
                  <span className="fs-24 toggle-icon"></span>
                </button>
                <div className="mx-auto">
                  <a className="navbar-brand d-inline-block mr-0" href="index.html">
                    <img src="/luminit-logo-1.png" alt={main_paige_title} />
                  </a>
                </div>
                <a href="/#" className="nav-link menu-cart" onClick={myCartHandler}>
                  <i className="far fa-shopping-basket"></i>
                  <span className="position-absolute number">{cartItems.length}</span>
                </a>
              </div>
            </nav>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
